import { useQuery } from "@tanstack/react-query";
import { getHealthService } from "@src/container";

const healthService = getHealthService();

/**
 * Hook to fetch system health status
 */
export function useSystemHealth(options?: {
    refetchInterval?: number;
    enabled?: boolean;
}) {
    return useQuery({
        queryKey: ["system", "health"],
        queryFn: async () => {
            const health = await healthService.getHealth();
            return health;
        },
        refetchInterval: options?.refetchInterval ?? 30000, // Default: refetch every 30 seconds
        enabled: options?.enabled ?? true,
        staleTime: 10000, // Consider data stale after 10 seconds
    });
}
